import { useCallback, useEffect } from 'react'
import { isPresent } from '../../../../lib/utils/collection'
import polygons from '../../../../lib/config/polygons.json'
import getLatLngLiteral from '../../../../lib/dataMappings/getLatLngLiteral'

const useMarkersBounds = ({ map, mapBounds, markers, valueStateStore }) => {
  const mapSetBounds = () => {
    map.panToBounds(mapBounds, 0)
    map.fitBounds(mapBounds, 0)
  }

  const mapFitBounds = bounds => {
    map.panToBounds(bounds)
    map.fitBounds(bounds)
  }

  const changeBoundsAccordingToBMarkers = useCallback(() => {
    if (!map) { return }

    const bounds = global.google && new global.google.maps.LatLngBounds()

    if (isPresent(mapBounds)) {
      mapSetBounds()
      return
    }

    if (isPresent(markers)) {
      markers.slice(0, 100).forEach(item => {
        bounds.extend(getLatLngLiteral(item))
      })
    } else {
      polygons.thehamptons.points.forEach(point => {
        bounds.extend(getLatLngLiteral(point))
      })
    }

    mapFitBounds(bounds)
  }, [map, markers, markers])

  useEffect(() => {
    changeBoundsAccordingToBMarkers()
  }, [map])

  useEffect(() => {
    if (!valueStateStore?.isTownChanged) {
      valueStateStore?.setTownChanged(false)
      return
    }

    changeBoundsAccordingToBMarkers()
  }, [valueStateStore?.isTownChanged, markers])
}

export default useMarkersBounds
